import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from './AuthProvider';
import { API_BASE_URL } from '../dppApi';

function ImageUploader() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [description, setDescription] = useState('');
  const [storageLocation, setStorageLocation] = useState('');
  const {user, isAuthenticated, accessToken, logout} = useContext(AuthContext);
  const navigate = useNavigate();

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);

    if (file) {
      const objectUrl = URL.createObjectURL(file);
      setPreviewUrl(objectUrl);
    } else {
      setPreviewUrl(null);
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) return;

    
    const formData = new FormData();
    formData.append("picture", selectedFile);
    formData.append("description", description);
    formData.append("storageLocation", storageLocation);
    formData.append("username", user);
  
    console.log(formData)

    try {

        const response = await 
        fetch(`${API_BASE_URL}/api/upload-photo`,
        //fetch('http://ec2-54-167-84-208.compute-1.amazonaws.com:5000/api/upload-photo',  
          {
        method: 'POST',
        body: formData
      });
      
      const data = await response.json();
      console.log('Data from Flask:', data);
      navigate('/jewellery');

    } catch (error) {
      console.error('Error uploading file:', error);
    }
  };

  return (
    <div class="App-body">
      <div>
      <input type="file" accept="image/*" onChange={handleFileChange} />
      {previewUrl && (
        <img src={previewUrl} alt="Preview" style={{ width: '200px', marginTop: '10px' }} />
      )}</div>
      <div>
      <input
        type="text"
        placeholder="Description"
        value={description}
        className="text-box-style"
        onChange={(e) => setDescription(e.target.value)}
      /></div>
      <div>
      <input
        type="text"
        placeholder="Storage Location"
        value={storageLocation}
        className="text-box-style"
        onChange={(e) => setStorageLocation(e.target.value)}
      /></div>
      <div><button onClick={handleUpload}>Upload file</button></div>
    </div>
  );
}

export default ImageUploader;